<template>
  <div class="row form-group">
    <div class="col-lg-12">
      <div class="col-lg-4">
        <fieldset>
          <label>
            Время смен
            <span v-if="!inputsWereDisabled" class="field__label_required">
              *
            </span>
            <slot name="after-label" />
          </label>
          <div class="field__inputs vert-scroll">
            <div
              v-if="hasDates"
              v-for="(time, date) in times"
              :key="date"
              class="inputs__input_time"
            >
              <div>
                <span>День</span>
                <input
                  class="form-control"
                  :value="getFormattedDate(date)"
                  readonly
                />
              </div>
              <div class="input__datepickers">
                <div v-for="timeType in timepickerTypes">
                  <span>{{ getTitle(timeType) }}</span>
                  <div>
                    <DatePicker
                      :key="timeType"
                      value-type="HH:mm"
                      type="time"
                      format="HH:mm"
                      v-model="time[timeType]"
                      :clearable="false"
                      :disabled="actionType === 'read'"
                      :disabled-time="notAfterTenHoursPM"
                      @confirm="(value) => (time[timeType] = value)"
                      confirm
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!hasDates" class="form-group">
            <span>Вначале добавьте любую дату</span>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { useTimepickers } from "@/user/mixins/shifts-calendar";
export default {
  mixins: [useTimepickers],
  components: {
    DatePicker,
  },
  props: {
    actionType: {
      type: String,
      required: true,
    },
    hasDates: {
      type: Boolean,
      default: false,
    },
    times: {
      type: Object,
      default() {
        return {};
      },
    },
    inputsWereDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
@keyframes input-appear {
  0% {
    transform: translateX(40%);
  }
  100% {
    transform: translateX(0);
  }
}
.field__button_pseudolink {
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer;
  color: #428bca;
  background-color: transparent;
  border: none;
}
.field__button_pseudolink:hover {
  opacity: 0.5;
  transition: 0.3s;
}
.field__inputs {
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
}
.inputs__input_time {
  animation: input-appear 0.5s;
}
.inputs__input_time,
.input__datepickers {
  display: grid;
  column-gap: 1em;
}
.inputs__input_time {
  grid-template-columns: max-content 50%;
}
.input__datepickers {
  grid-template-columns: repeat(2, 35%);
}
.inputs__input_time .mx-datepicker {
  width: auto;
}
.inputs__input_time:not(:last-child) {
  margin-bottom: 1em;
}
@media (max-width: 767px) {
  .input__datepickers {
    grid-template-columns: repeat(2, 50%);
  }
  .inputs__input_time {
    display: flex;
    flex-direction: column;
  }
  .input__datepickers {
    margin-top: 1em;
  }
  .inputs__input_time .mx-datepicker {
    width: 100%;
  }
}
@media (max-width: 419px) {
  .input__datepickers {
    display: flex;
    flex-direction: column;
    row-gap: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/user/components/shifts-calendar/TimesList.vue